import BaseLayer from "./BaseLayer";
import {drawRectangle} from "../utils/map_utils";
import {isTrue, notNull} from "utils/utils";

class TXTYPattern extends BaseLayer {
    id = this.props.controller;
    label = this.props.controller;
    defaultVisible = this.props.tileViewerState[this.id];

    getTileMarkers = (x, y, tile_height, tile_width, uperpixel, is_north) => {
        let bound1, bound2;
        if (is_north) {
            // NORTH MARKERS
            bound1 = [
                [(x + 0.1) * (tile_width * uperpixel), (y - (0.1) + 1) * (tile_height * uperpixel)],
                [(x + (1 - 0.55)) * (tile_width * uperpixel), (y - (0.1) + 1) * (tile_height * uperpixel)],
                [(x + (1 - 0.55)) * (tile_width * uperpixel), (y + (0.1) + 1) * (tile_height * uperpixel)],
                [(x + 0.1) * (tile_width * uperpixel), (y + (0.1) + 1) * (tile_height * uperpixel)],
                [(x + 0.1) * (tile_width * uperpixel), (y - (0.1) + 1) * (tile_height * uperpixel)]
            ];
            bound2 = [
                [(x + 0.55) * (tile_width * uperpixel), (y - (0.1) + 1) * (tile_height * uperpixel)],
                [(x + (1 - 0.1)) * (tile_width * uperpixel), (y - (0.1) + 1) * (tile_height * uperpixel)],
                [(x + (1 - 0.1)) * (tile_width * uperpixel), (y + (0.1) + 1) * (tile_height * uperpixel)],
                [(x + 0.55) * (tile_width * uperpixel), (y + (0.1) + 1) * (tile_height * uperpixel)],
                [(x + 0.55) * (tile_width * uperpixel), (y - (0.1) + 1) * (tile_height * uperpixel)]
            ];
        } else {
            // WEST MARKERS
            bound1 = [
                [(x - (0.07)) * (tile_width * uperpixel), (y + 0.1) * (tile_height * uperpixel)],
                [(x - (0.07)) * (tile_width * uperpixel), (y + (1 - 0.55)) * (tile_height * uperpixel)],
                [(x + (0.07)) * (tile_width * uperpixel), (y + (1 - 0.55)) * (tile_height * uperpixel)],
                [(x + (0.07)) * (tile_width * uperpixel), (y + 0.1) * (tile_height * uperpixel)],
                [(x - (0.07)) * (tile_width * uperpixel), (y + 0.1) * (tile_height * uperpixel)]
            ];
            bound2 = [
                [(x - (0.07)) * (tile_width * uperpixel), (y + 0.55) * (tile_height * uperpixel)],
                [(x - (0.07)) * (tile_width * uperpixel), (y + (1 - 0.1)) * (tile_height * uperpixel)],
                [(x + (0.07)) * (tile_width * uperpixel), (y + (1 - 0.1)) * (tile_height * uperpixel)],
                [(x + (0.07)) * (tile_width * uperpixel), (y + 0.55) * (tile_height * uperpixel)],
                [(x - (0.07)) * (tile_width * uperpixel), (y + 0.55) * (tile_height * uperpixel)]
            ];
        }
        return [bound1, bound2];
        
    }

    getTileColor = (delta, is_north, is_x) => {
        const totalDivision = 255 
        let color = [255, 0, 0];
        let val;
        if (is_north) {
            if (is_x) {
                val = Math.floor(((delta - this.props.minNorthX) * totalDivision) / (this.props.maxNorthX - this.props.minNorthX));
            } else {
                val = Math.floor(((delta - this.props.minNorthY)* totalDivision) / (this.props.maxNorthY - this.props.minNorthY));
            }
        } else {
            if (is_x) {
                val = Math.floor(((delta - this.props.minWestX)* totalDivision) / (this.props.maxWestX - this.props.minWestX));
            } else {
                val = Math.floor(((delta - this.props.minWestY)* totalDivision) / (this.props.maxWestY - this.props.minWestY));
            }
        }
        
        color[1] = val;
        return `rgba(${color[0]},${color[1]},${color[2]},0.8)`
    }

    draw = () => new Promise((resolve, reject) => {
        let {scanMeta, textColor, controller} = this.props;

        for (let key in scanMeta) {
            if (key.endsWith("_5"))
                continue;

            let {y_fields, tile_width, tile_height, uperpixel} = this.props.slide;
            
            let x = scanMeta[key]["col"];
            let y = scanMeta[key]["row"];
            y = y_fields - y - 1;

            if (controller === "NTX" || controller === "NTY") {
                if (notNull(scanMeta[key]["top"])){
                    let tileColorY = '#000000';
                    let tileColorX = '#000000';
                    if (isTrue(scanMeta[key]["top"]["success"])) {
                        tileColorY = this.getTileColor(scanMeta[key]["top"]["ty"], true, false);
                        tileColorX = this.getTileColor(scanMeta[key]["top"]["tx"], true, true);
                    }
                    const bounds = this.getTileMarkers(x, y, tile_height, tile_width, uperpixel, true);
                    if (controller === "NTX") {
                        drawRectangle(bounds[0], this.layer.getSource(), true, 2, tileColorX,
                                "", textColor);
                    } else if (controller === "NTY") {
                        drawRectangle(bounds[1], this.layer.getSource(), true, 2, tileColorY,
                                "", textColor);
                    }
                }
            }
            
            if (controller === "WTX" || controller === "WTY") {
                if (notNull(scanMeta[key]["left"])) {
                    if (isTrue(scanMeta[key]["left"]["success"])) {
                        const bounds = this.getTileMarkers(x, y, tile_height, tile_width, uperpixel, false);
                        if (controller === "WTX") {
                            const tileColorX = this.getTileColor(scanMeta[key]["left"]["tx"], false, true);
                            drawRectangle(bounds[0], this.layer.getSource(), true, 2, tileColorX,
                                    "", textColor);
                        }
                        else if (controller === "WTY") {
                            const tileColorY = this.getTileColor(scanMeta[key]["left"]["ty"], false, false);
                            drawRectangle(bounds[1], this.layer.getSource(), true, 2, tileColorY,
                                    "", textColor);
                        }
                    }
                }
            }
        }
        resolve();
    });
}

export default TXTYPattern;
